import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import { BylineConnectionsPlaceholder } from '../src/ssr/BylineConnectionsPlaceholder.tsx';

export type { DevDocsBylineConnectionAncestor } from '../src/BylineConnections.tsx';

// Keep the header independent of slower tasks in the after-paint queue.
export const BylineConnections: LoadableType<any> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BylineConnections" */ '../src/BylineConnections.tsx'
			)
		).BylineConnections,
	loading: BylineConnectionsPlaceholder,
});
